import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp, throwIfResultHasErrors } from 'src/lib/graphql';
import type { BackendQueryInviteDetailsArgs, BackendUserInvite } from 'src/types/backend';

import { USER_INVITE_FRAGMENT } from './schema';

const QUERY = gql`
  query InviteDetails($token: String!) {
    inviteDetails(token: $token) {
      ...UserInvite
    }
  }
  ${USER_INVITE_FRAGMENT}
`;

type Variables = BackendQueryInviteDetailsArgs;
type Result = BackendUserInvite;

export const queryInviteDetails = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  throwIfResultHasErrors(result);
  return getSingleProp<Result>(result.data);
};
